module.exports = __webpack_public_path__ + "static/media/geoasma-nav.aab6ce31.png";